import {applySpec, filter, flow, get, map} from '@yandex-delivery/utils'

import {appConfig} from 'src/shared/config'
import type {FormOrderResponse, TariffVertical, Vertical} from 'src/shared/types'

export const tagToUrl = (vertical: Vertical): string | undefined =>
  vertical.image_tag ? `${appConfig.yaAuthProxyHost}/3.0/getimage?tag=${vertical.image_tag}&size_hint=9999` : undefined

const toTariffVertical: (vertical: Vertical) => TariffVertical = applySpec<TariffVertical>({
  id: get('id'),
  title: get('title'),
  description: get('subtitle'),
  imgSrc: tagToUrl,
  requirements: get('supported_requirements'),
  dueSettings: get('due_settings'),
  deliveryIntervals: get('delivery_intervals'),
  bduiParams: {mode: get('bdui.mode'), defaultValues: get('bdui.default_values')},
})

export const toTariffVerticals: (formOrder?: FormOrderResponse) => TariffVertical[] = flow(
  get('verticals'),
  map(toTariffVertical),
  filter(vertical => vertical?.id !== 'cargo_intercity'),
)
